// Build-time environment selection.
//
// For Docker image builds, pass --build-arg BUILD_ENV=<value> which sets
// RAZZLE_BUILD_ENV before `pnpm build`. Razzle bakes the value into the bundle.
//
// Valid values: sit | stg | prd | chs-dev
// Missing or invalid values fail the build instead of silently producing a SIT image.

import { environment as chsDev } from './environment.chs-dev';
import { environment as prd } from './environment.prd';
import { environment as sit } from './environment.sit';
import { environment as stg } from './environment.stg';

const buildEnv = process.env.RAZZLE_BUILD_ENV;

const environments = {
  sit,
  stg,
  prd,
  'chs-dev': chsDev,
} as const;

if (!buildEnv || !(buildEnv in environments)) {
  throw new Error(
    `RAZZLE_BUILD_ENV must be one of ${Object.keys(environments).join(', ')}. Received: ${buildEnv || '<unset>'}`,
  );
}

export const environment = environments[buildEnv as keyof typeof environments];
